import { computed, useHead } from '#imports';
import type { RouteLocationNormalizedLoadedGeneric } from '#vue-router';

export default function useMetaCollections({ route }: {
    route: RouteLocationNormalizedLoadedGeneric;
}) {
    const routeMetaWithoutParams = computed(() => import.meta.env.VITE_DOMEN_URL + route.path);
    const routeMetaWithParams = computed(() => import.meta.env.VITE_DOMEN_URL + route.fullPath);

    const runtimeConfig = useRuntimeConfig();

    const metaImages = computed(() => {
        if (runtimeConfig.public.name === 'GMBZR') {
            return [
                ...runtimeConfig.public.metaImages,
                {
                    property: 'og:image',
                    content: '/gmbzr/og_1200x630_collections.jpg'
                },
                {
                    name: 'twitter:image',
                    content: '/gmbzr/og_1200x630_collections.jpg'
                }
            ];
        }
        return runtimeConfig.public.metaImages;
    });

    useHead({
        title: `Discover NFTs | ${runtimeConfig.public.name}`,
        meta: [
            {
                name: 'description',
                content: `Navigate through the top NFT collections. Find unique digital assets on the ${runtimeConfig.public.name} marketplace.`
            },
            {
                property: 'og:title',
                content: `Discover NFTs | ${runtimeConfig.public.name}`
            },
            {
                name: 'keywords',
                content: `top nft collections discover nft nft collections marketplace ${runtimeConfig.public.name} nft collections explore unique digital assets`
            },
            ...metaImages.value,
            {
                property: 'og:image:alt',
                content: `Discover NFTs | ${runtimeConfig.public.name}`
            },
            {
                property: 'og:description',
                content: `Navigate through the top NFT collections. Find unique digital assets on the ${runtimeConfig.public.name} marketplace.`
            },

            {
                name: 'twitter:title',
                content: `Discover NFTs | ${runtimeConfig.public.name}`
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:url',
                content: routeMetaWithoutParams
            },
            {
                name: 'twitter:creator',
                content: `Navigate through the top NFT collections. Find unique digital assets on the ${runtimeConfig.public.name} marketplace.`
            },
            {
                name: 'twitter:description',
                content: `Navigate through the top NFT collections. Find unique digital assets on the ${runtimeConfig.public.name} marketplace.`
            }
        ],
        link: [
            {
                rel: 'canonical',
                href: routeMetaWithParams
            },
            {
                rel: 'preconnect',
                href: routeMetaWithParams
            },
            {
                rel: 'dns-prefetch',
                href: routeMetaWithParams
            }
        ]
    });
}
